import { render, staticRenderFns } from "./InitOfferClientHistory.vue?vue&type=template&id=22115562"
import script from "./InitOfferClientHistory.vue?vue&type=script&lang=js"
export * from "./InitOfferClientHistory.vue?vue&type=script&lang=js"
import style0 from "./InitOfferClientHistory.vue?vue&type=style&index=0&id=22115562&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports